'use client';

import { AnimatePresence, motion } from 'framer-motion';

interface ImageZoomProps {
    isOpen: boolean;
    onClose: () => void;
    src: string;
    alt?: string;
}

export default function ImageZoom({ isOpen, onClose, src, alt = '' }: ImageZoomProps) {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-50 backdrop-blur-sm bg-color-base-2/40 flex items-center justify-center"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.img
                        src={src}
                        alt={alt}
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        transition={{ type: 'spring', stiffness: 300, damping: 25 }}
                        className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-xl"
                        onClick={(e) => e.stopPropagation()} // 画像クリックでは閉じない
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
}
